import { Badge } from '../../Badge/Badge';
import { useInstallmentsTranslation } from './i18n';

export interface InstallmentManualBadgeProps {
  /** Valor auto-generado original (de `autoGeneratedSnapshot.amount`), ya formateado. */
  autoAmountLabel?: string;
}

/**
 * Badge "Manual" de una cuota editada (FEAT-105-7.02).
 *
 * Reutiliza el `Badge` del kit (color `amber`, ADAPTACIÓN A3). El tooltip
 * (atributo `title` nativo, ADAPTACIÓN A2) muestra el valor automático original
 * cuando está disponible.
 */
export function InstallmentManualBadge({ autoAmountLabel }: InstallmentManualBadgeProps) {
  const { t } = useInstallmentsTranslation();
  const tooltip = autoAmountLabel
    ? t('installments.badge.manualTooltip', { amount: autoAmountLabel })
    : undefined;

  return <Badge color="amber" label={t('installments.badge.manual')} title={tooltip} />;
}
